import { prepareHeader } from "./layout/prepareHeader";
import { prepareFooter } from "./layout/prepareFooter";
import { onDocumentReady } from "./utils/onDocumentReady";

onDocumentReady(() => {
  prepareHeader();
  prepareFooter();
});
